const actionBase = 'DASHBOARD_CONTRACT_MOVEMENT'
const STATE = {
  contract_movement: null,
  errMsg: null,
  loading: false,
}

export function contractMovement(action){

  switch (action.type) {

    // On Pending
    case `${actionBase}_LOAD_REQUEST`:
      return {...STATE, loading: true}

    // On success request
    case `${actionBase}_LOAD_SUCCESS`:
      return {
        ...STATE,
        contract_movement: action.payload.contract_movement,
        loading: false
      }

    // On failed request
    case `${actionBase}_LOAD_FAILURE`:
      return {
        ...STATE,
        errMsg: action.payload,
        loading: false
      }

    default:
      return STATE

  }

}
